module.exports = __webpack_public_path__ + "img/strawberry-raspberry.0966c961.png";